import React from 'react';
import Orders from './Orders/Orders';

function Home() {
  return <Orders />;
}

export default Home;
